/** @jsx jsx */
import { Card, CardContent, Box, Typography, Grid } from '@material-ui/core';
import { jsx } from '@emotion/core';

import { IChallengeListProductItem } from 'interfaces';
import ProductThumbnail from '../../ProductsDetailsList/ProductsThumbnail';
import * as S from './styles';

interface IProduct {
  product: IChallengeListProductItem;
  getProductTitle: (product: IChallengeListProductItem) => string;
  isDisabled?: boolean;
}

export default function Product({
  product,
  getProductTitle,
  isDisabled,
}: IProduct) {
  return (
    <Card css={S.cssCard}>
      <Box css={S.getCssHeader(isDisabled)}>
        <Typography variant="body2" align="right" css={S.cssHeaderTitle}>
          {getProductTitle(product)}
        </Typography>
      </Box>
      <Grid css={S.cssProductDetails}>
        <Grid>
          <Typography variant="body2" css={S.getCssRange(isDisabled)}>
            {product.challengeProduct.range}
          </Typography>
        </Grid>
        <Grid>
          <Typography variant="body2">
            {product.challengeProduct.unit}
          </Typography>
        </Grid>
        <Grid>
          <Typography variant="body2">
            <span css={S.cssBold}>{product.challengeProduct.brand}</span>
            {product.challengeProduct.brand && <span> - </span>}
            {product.challengeProduct.productName}
          </Typography>
        </Grid>
        <Grid>
          <Typography variant="body2">
            {product.challengeProduct.productCode}
          </Typography>
        </Grid>
        <Grid>
          {product.challengeProduct.productDescription && (
            <Typography variant="body2" css={S.cssProductDescription}>
              {product.challengeProduct.productDescription}
            </Typography>
          )}
        </Grid>
      </Grid>
      <CardContent>
        <ProductThumbnail thumbnail={product.challengeProduct.visual} />
      </CardContent>
    </Card>
  );
}
